import { localToGlobalForce } from '@scene'
import numeral from 'numeral'

export const lineLoadForceFormatter = (value: number) => {
  const valueInKilos = value / 1000
  const formatter = '0[.][00]'
  return `${numeral(valueInKilos).format(formatter)}`
}

export const lineLoadForceValueGetter = (force: Force, domain: Domain) => {
  const globalForce = localToGlobalForce(force, domain)
  const globalForceZ = globalForce.z
  return Math.abs(globalForceZ) < 1.0e-3 ? 0 : globalForceZ
}
